import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tooltip" }, " Escribe al menos 3 caracteres ", -1)
const _hoisted_2 = [
  _hoisted_1
]

import { isValidQuery } from "@/busData";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, _hoisted_2, 512)), [
    [_vShow, !_unref(isValidQuery)]
  ])
}
}

})